import PropTypes from 'prop-types';
import React from 'react';
import RCUIOverlay from './RCUIOverlay';
import RCUIButtonLink from './RCUIButtonLink';
import trackingAdapter from '../../routes/searchResult/tracking/trackingAdapter';
import styles from './AccountOverlay.scss';
import { getAccountLink, SIGN_IN_PATH, SIGN_UP_PATH } from '../accountLinks';

export const AccountOverlay = ({ heading, content, image, isDisplayed, closeFn }) => {
  if (isDisplayed) {
    const continueUrl = `${window.location.pathname}${window.location.search}`;

    return (
      <RCUIOverlay
        isOpen
        id="accountNotificationOverlay"
        closeFn={closeFn}
        overlayClasses={styles.wrapper}
        closeButtonClasses={styles.closeButton}
        allowScroll
      >
        {image}
        <div className={styles.contentWrapper}>
          <h2 className={styles.heading}>{heading}</h2>
          <p className={styles.content}>{content}</p>
          <div className={styles.buttonWrapper}>
            <RCUIButtonLink
              type="primary"
              href={getAccountLink({ path: SIGN_UP_PATH, continueUrl })}
              onClick={trackingAdapter.trackCreateAccountModalClick}
            >
              Create account
            </RCUIButtonLink>
            <RCUIButtonLink
              type="defaultBlue"
              href={getAccountLink({ path: SIGN_IN_PATH, continueUrl })}
              onClick={trackingAdapter.trackSignInModalClick}
            >
              Sign in
            </RCUIButtonLink>
          </div>
        </div>
      </RCUIOverlay>
    );
  }
  return null;
};

AccountOverlay.propTypes = {
  heading: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  image: PropTypes.element.isRequired,
  isDisplayed: PropTypes.bool,
  closeFn: PropTypes.func.isRequired,
};

export default AccountOverlay;
